export let FLEXIBLE = {value: "flexible", enum: 'FLEXIBLE'};
let ZERO = {value: "0", enum: 'ZERO'};
let ONE = {value: "1", enum: 'ONE'};
let TWO = {value: "2", enum: 'TWO'};
let THREE = {value: "3", enum: 'THREE'};
let FOUR = {value: "4", enum: 'FOUR'};
let FIVE = {value: "5", enum: 'FIVE'};
let SIX = {value: "6", enum: 'SIX'};
let SEVEN = {value: "7", enum: 'SEVEN'};
let EIGHT = {value: "8", enum: 'EIGHT'};
let NINE = {value: "9", enum: 'NINE'};
let TEN = {value: "10", enum: 'TEN'};
let ELEVEN = {value: "11", enum: 'ELEVEN'};
let TWELVE = {value: "12", enum: 'TWELVE'};
let THIRTEEN = {value: "13", enum: 'THIRTEEN'};
let FOURTEEN = {value: "14", enum: 'FOURTEEN'};
let FIFTEEN = {value: "15", enum: 'FIFTEEN'};
let SIXTEEN = {value: "16", enum: 'SIXTEEN'};
let SEVENTEEN = {value: "17", enum: 'SEVENTEEN'};
let EIGHTEEN = {value: "18", enum: 'EIGHTEEN'};
let NINETEEN = {value: "19", enum: 'NINETEEN'};
let TWENTY = {value: "20", enum: 'TWENTY'};
let TWENTY_ONE = {value: "21", enum: 'TWENTY_ONE'};
let TWENTY_TWO = {value: "22", enum: 'TWENTY_TWO'};
let TWENTY_THREE = {value: "23", enum: 'TWENTY_THREE'};

export let all = [
    FLEXIBLE,
    ZERO,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    NINE,
    TEN,
    ELEVEN,
    TWELVE,
    THIRTEEN,
    FOURTEEN,
    FIFTEEN,
    SIXTEEN,
    SEVENTEEN,
    EIGHTEEN,
    NINETEEN,
    TWENTY,
    TWENTY_ONE,
    TWENTY_TWO,
    TWENTY_THREE
];


// WEBPACK FOOTER //
// ./src/constants/CheckTime.js